import React, { useState } from 'react'

import {
  Grid,
  Typography,
  Button,
  TextField,
  CircularProgress
} from '@mui/material'
import SaveIcon from '@mui/icons-material/Save'
import { Status } from '../../../hooks/useFetchState'
import { patchIventoryCheck } from '../api'
import { useApi } from '../../../hooks/useApi'
import { Filter } from "../../../components/_WMS/FilterComponent"

interface ChangeWorkOrderTagComponentProps {
  loading?: boolean
  actualTag: string
  workOrderIds: number[]
  handleSnackbar: (message: string, success: boolean) => void
  handleCloseModal:() => void
  requestInventoryCheck : (
    filters?: Filter[],
    page?: number,
    pageSize?: number) => void
}



export const ChangeInventoryCheckTagComponent: React.FC<ChangeWorkOrderTagComponentProps> =({ 
    workOrderIds, 
    actualTag, 
    loading = false, 
    handleSnackbar,
    handleCloseModal ,
    requestInventoryCheck
    }) => {
    const [newTag, setNewTag] = useState(actualTag)

    const { state, callApi } = useApi()

    const requestSetNewTagWorkOrder = () => {
      callApi(patchIventoryCheck(workOrderIds, newTag.trim()))
        .then(() => {  
          setNewTag(newTag.trim());
          handleSnackbar('Tag actualizado correctamente', true)
          requestInventoryCheck()
          handleCloseModal()
        })
        .catch(({ data: { message } }) => {
            handleCloseModal()
            handleSnackbar(message, false)
        })
    }

    const isLoading = state.status === Status.Loading || loading

    return (
      <Grid container direction='row' item xs={12} spacing={3}>
        <Grid item xs={12} sm={4}>
          <Typography>Modificar Tag</Typography>
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            variant='outlined'
            value={newTag}
            onChange={(e) => {
                setNewTag(e.target.value);
            }}
            disabled={isLoading}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Button
            disabled={isLoading || newTag === actualTag || newTag.trim().length <= 1}
            variant='contained'
            color='primary'
            onClick={requestSetNewTagWorkOrder}
            endIcon={isLoading ? <CircularProgress size={'14px'} /> : <SaveIcon/>}
          >
          </Button>
        </Grid>
      </Grid>
    )
  }
